import { useEffect } from 'react';
import { filterWidgetEvent } from '@client/foundation/shared/utils/filter-widget-event';
import { useWidget } from '@client/widgets/widget.hook';
import { WidgetPayload } from '@client/widgets/widget.types';
import { useWindow } from '@client/window/window.hook';

export const useDialogWindowEvents = () => {
  const { openWidget$ } = useWidget();
  const { openWindow } = useWindow();

  useEffect(() => {
    const subscription = openWidget$()
      .pipe(
        filterWidgetEvent<WidgetPayload, 'ConfirmationDialog'>(
          'ConfirmationDialog'
        )
      )
      .subscribe((payload) => {
        openWindow({
          type: 'ConfirmationDialog',
          componentProps: {
            title: payload.title,
            description: payload.description,
            cancelLabel: payload.cancelLabel,
            confirmLabel: payload.confirmLabel,
            intent: payload.intent,
            confirmDisabled: payload.confirmDisabled,
            onConfirm: payload.onConfirm,
            onCancel: payload.onCancel
          }
        });
      });

    return () => subscription.unsubscribe();
  }, [openWidget$, openWindow]);
};
